module.exports = __webpack_public_path__ + "img/project-diagram.330cd1d7.svg";